declare function require(moduleName: any): any;

export const environment = {
  amplitude: '9babb2224f56f9d7889aa94f9da987b5',
  recaptchaV2InvisibleSiteKey: '6LeN_U0rAAAAAN2_YwMwj4_Kci9qOiRQvED53euQ',
  typeForm: 'CzfYt6Mh',
  production: true,
  env: 'prod',
  apiUrlMock: 'http://localhost:3000',
  apiUrl: 'https://api.marsaude.net/v1',
  loginRedirect: 'https://app.marsaude.net',
  version: require('../../package.json').version,
  build: require('../../package.json').build,
  company: {
    name: 'Mar Saúde',
  },
  disableAnimationIntro: false,
};
